import {EmptyBodyText, EmptyBodyContainer} from './layout/index.styled';

export function EmptyBody() {
	return <EmptyBodyContainer>
        <EmptyBodyText size='small'>
            Select an Activity
        </EmptyBodyText>
    </EmptyBodyContainer>;
}